import { MdQrCode2 } from 'react-icons/md';
import { mainPresentation } from './Global/Presentation'
import { cme_kurs } from './Global/Kurs'
import { formatDateToString } from './Global/functions'

import parse from 'html-react-parser'

import cmeducationLogo from './../img/cmeducation_logo.png'

import SpeakerCV from './ReferentCV'
import Popup from './Popup'
import ReferentButton from './ReferentButton'


export const InfoContainer = ({ isHidden = true }) => {
    var info = cme_kurs.Info;
    var referenten = cme_kurs.Referenten;
    var aerztlicheLeiter = cme_kurs.AerztlicherLeiter;
    return (
        <div className="info-container" hidden={isHidden}>

            <div className="page-section--weiss">
                <div className="page-section-padding">
                    <div className="sectionTitel">
                        {cme_kurs.KursTitel}<br />
                        {(cme_kurs.KursUntertitel) ? <div className="sectionSubTitel">{cme_kurs.KursUntertitel}</div> : ""}
                    </div>
                </div>
            </div>

            <div className="page-section--hellgrau">
                <div className="page-section-padding">

                    {/* BESCHREIBUNG */}
                    <u>Beschreibung</u>
                    <div>{cme_kurs.KursBeschreibung ? parse(cme_kurs.KursBeschreibung) : ""}</div><br />

                    {/* ÄRZTLICHER LEITER */}
                    {aerztlicheLeiter.length ?
                        <>
                            <u>Ärztliche Leitung</u>
                            <div className="referenten-container">
                                {/* Iteriere alle ärztlichen Leiter */}
                                {aerztlicheLeiter.map((aerztLeiter, index) => (
                                    <div key={"aerzt-leiter-" + index} className="gruppe-tags">
                                        <Popup
                                            id={`aerzt-leiter-${index}`}
                                            popupContent={() => <SpeakerCV referent={aerztLeiter} />}
                                            Button={<ReferentButton referent={aerztLeiter} />}
                                        />
                                    </div>
                                ))}
                            </div>
                        </>
                        : <></>
                    }

                    {/* REFERENTEN */}
                    {referenten.length ?
                        <>
                            <u>
                                {cme_kurs.KursTyp === "PDF" || cme_kurs.KursTyp === "PowerPoint" ? // autor for pdf/powerpoint and referent for video
                                    <>Autor*in{referenten.length > 1 ? "nen" : ""/* add plural */}</>
                                    :
                                    <>Referent*in{referenten.length > 1 ? "nen" : ""/* add plural */}</>
                                }
                            </u>

                            <div className="referenten-container">
                                {/* Iteriere alle Referentn */}
                                {referenten.map((referent, index) => (
                                    <div key={"referent-" + index} className="gruppe-tags">
                                        <Popup
                                            id={`referenten-${index}`}
                                            popupContent={() => <SpeakerCV referent={referent} />}
                                            Button={<ReferentButton referent={referent} />}
                                        />
                                    </div>
                                ))}
                            </div>
                        </>
                        : <></>
                    }
                </div>
            </div>


            {/* WEITERE ANGABEN */}
            <div className="page-section--weiss gender-info-container">
                {cme_kurs.isCertified ?
                    <div className="page-section-padding">
                        <u>Weitere Angaben</u><br />
                        <div><span className="text-label">VNR: </span>{cme_kurs.VNR}</div>
                        <div><span className="text-label">Gültig bis: </span>{formatDateToString(cme_kurs.Laufzeit_Ende)}</div>
                        <div><span className="text-label">Fortbildungsart: </span>{cme_kurs.Fortbildungsart}</div>
                        <div><span className="text-label">Fortbildungskategorie: </span>{cme_kurs.Fortbildungskategorie}</div>
                        <div><span className="text-label">CME-Punkte: </span>{cme_kurs.CME_Punkte}</div>
                        <div><span className="text-label">Kosten: </span>{cme_kurs.Kosten}</div>

                    </div>
                    : <></>
                }
                <div className={`page-section-padding gender-info ${!cme_kurs.isCertified ? "not-certifided" : ""}`}>
                    <u>Hinweis</u>
                    <p>Aus Gründen der besseren Lesbarkeit wird auf die gleichzeitige Verwendung der Sprachformen männlich, weiblich und divers (m/w/d) verzichtet. Sämtliche Personenbezeichnungen gelten gleichermaßen für alle Geschlechteridentitäten</p>
                </div>
            </div>


            {/* SPONSOR */}
            {cme_kurs.Sponsor_Name && cme_kurs.Sponsor_Name !== "Kein Sponsor" ?
                <div className="page-section--weiss">
                    <div className="page-section-padding">
                        <div>Mit freundlicher Unterstützung von: {cme_kurs.Sponsor_Name}</div>
                        {cme_kurs.Sponsor_Logo ? <img className="sponsor-logo" src={require(`./../img/sponsors/${cme_kurs.Sponsor_Logo}`)} /> : <i style={{ color: 'red' }}>Kein Sponsoren-Logo definiert</i>}
                        {cme_kurs.Sponsor_Info ? <div className="text-klein">{parse(cme_kurs.Sponsor_Info)}</div> : <></>}
                    </div>
                </div>
                : ""
            }


            {/* QR-CODE GENERATOR */}
            {(cme_kurs.qrCodeGeneratorActive) ?
                <div className="reiter qr-code-reiter" onClick={(e) => mainPresentation.toggleReiter(e)}>
                    <MdQrCode2 />
                    <p>{cme_kurs.QRCodeTitel}</p>
                    <br />
                </div>
                : ""
            }


            {/* KURSINFORMATIONEN */}
            <div className="page-section--weiss">
                <div className="page-section-padding">
                    {(info.Allgemein.Titel && cme_kurs.isCertified) ? <div className="sectionTitel">{info.Allgemein.Titel}</div> : <></>}
                    {(info.Allgemein.Zielgruppe && cme_kurs.isCertified) ? <u>Zielgruppe</u> : <></>}
                    {(info.Allgemein.Zielgruppe && cme_kurs.isCertified) ? <><div>{parse(info.Allgemein.Zielgruppe)}</div><br /></> : <></>}
                    {(info.Allgemein.Lernziele && cme_kurs.isCertified) ? <u>Lernziele</u> : <></>}
                    {(info.Allgemein.Lernziele && cme_kurs.isCertified) ? <><div>{parse(info.Allgemein.Lernziele)}</div><br /></> : <></>}
                    {(info.Allgemein.Zertifizierung && cme_kurs.isCertified) ? <u>Zertifizierung</u> : <></>}
                    {(info.Allgemein.Zertifizierung && cme_kurs.isCertified) ? <><div>{parse(info.Allgemein.Zertifizierung)}</div><br /></> : <></>}
                    {(info.Allgemein.Hinweis) ? <u>Hinweis</u> : <></>}
                    {(info.Allgemein.Hinweis) ? <><div>{parse(info.Allgemein.Hinweis)}</div><br /></> : <></>}
                    {(info.Allgemein.Funktionsweise && cme_kurs.isCertified) ? <u>Bearbeitung des CME-Kurses</u> : <></>}
                    {(info.Allgemein.Funktionsweise && cme_kurs.isCertified) ? <><div>{parse(info.Allgemein.Funktionsweise)}</div><br /></> : <></>}
                    {(info.Allgemein.NachsterSchritt && cme_kurs.isCertified) ? <u>Was passiert dann?</u> : <></>}
                    {(info.Allgemein.NachsterSchritt && cme_kurs.isCertified) ? <><div>{parse(info.Allgemein.NachsterSchritt)}</div><br /></> : <></>}
                </div>
            </div>


            {/* TUTORIELLE UNTERSTÜTZUNG */}
            {info.TutorielleUnterstuetzung.Text && cme_kurs.isCertified ?
                <div className="page-section--hellgrau">
                    <div className="page-section-padding">
                        <div className="sectionTitel">{info.TutorielleUnterstuetzung.Titel}</div>
                        <div>{parse(info.TutorielleUnterstuetzung.Text)}</div>
                    </div>
                </div>
                : (<></>)
            }


            {/* IMPRESSUM */}
            <div className="page-section--weiss">
                <div className="page-section-padding">
                    <div className="sectionTitel">{info.Impressum.Titel}</div>
                    <u>Vertrieb</u>
                    <div>{parse(info.Impressum.Vertrieb)}</div>
                    <div><a href="https://cmeducation.de/" target="_blank"><img src={cmeducationLogo} className="cmeducation-logo" alt="cmEducation-Logo" /></a></div><br />
                    <u>Herausgeber</u>
                    <div>{parse(info.Impressum.Herausgeber)}</div>
                </div>
            </div>

            {/* HAFTUNGSAUSSCHLUSS */}
            {cme_kurs.isCertified ?
                <div className="page-section--hellgrau">
                    <div className="page-section-padding">
                        <div className="sectionTitel">{info.Haftungsausschluss.Titel}</div>
                        <div>{parse(info.Haftungsausschluss.Text)}</div>
                    </div>
                </div>
                : <></>
            }


            {/* DATENSCHUTZ */}
            <div id="datenschutz-erklaerung" className="page-section--weiss">
                <div className="page-section-padding">
                    <div className="sectionTitel">{info.Datenschutz.Titel}</div>

                    <div><u>reCAPTCHA</u></div>
                    <p>Auf dieser Website wurde reCAPTCHA implementiert. Die Nutzung von reCAPTCHA unterliegt der <a href="https://www.google.com/policies/privacy/" target="_blank">Datenschutzerklärung</a> und den <a href="https://www.google.com/policies/terms/" target="_blank">Nutzungsbedingungen</a> von Google.</p>
                    <br />

                    <div>{parse(info.Datenschutz.Text)}</div>
                </div>
            </div>

        </div>
    )
}

export default InfoContainer